import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStores } from '../../hooks/use-stores';
import startCase from 'lodash/startCase';
import './IOChange.scss';

export interface IOChangeItem {
  name?: string;
  type?: string;
  value?: number;
  oldValue?: number;
  testValue?: number;
};

export interface IOChangeProps {
  changeList: IOChangeItem[];
  onIOTest: () => void;
};

export const IOChange: React.FC<IOChangeProps> = ({ changeList, onIOTest }) => {
  const { t } = useTranslation();
  const { batchStore, locationsStore } = useStores();
  const { currentPlant } = locationsStore;

  return (
    <div className="io-change">
      <p>
        {t('This I/O has been changed for')} {batchStore.currentTenantSlug?.toUpperCase()} {currentPlant.code} {currentPlant.description}.
      </p>
      <p>
        {t('Please test the device to ensure the change is configured correctly.')}
      </p>
      {changeList.map((item, index) => (
        <div key={index} className="io-change-item">
          <span className="item-name">{startCase(item.name)}:</span>
          <span className="change-from">{item.oldValue}</span>
          <i className="fa fa-arrow-right-long"/>
          <span className="change-to">{item.value}</span>

          <button
            className="btn btn-default"
            onMouseDown={() => {
              batchStore.setOutput(item.testValue, '!');
              onIOTest();
            }}
            onMouseUp={() => {
              batchStore.setOutput(item.testValue, '0');
            }}
          >
            {t('Test')}
          </button>
          <span className="error">
            {t('Test is required!')}
          </span>

        </div>
      ))}

      <p>{t('Are you sure you want to save this change?')}</p>
    </div>
  );
};
